export default {
  getToken(store) {
    return store.authToken;
  },
  isLogged(store) {
    return store.authToken && store.authToken !== '';
  },
  isOfficeLogin(store) {
    return store.officeLogin;
  },
  isParentProfile(store) {
    return !!(store.currentProfile === 'ROLE_PARENT');
  },
  isAgentProfile(store) {
    return !!(store.currentProfile === 'ROLE_LECTOR');
  },
  isAdditionalAccessProfile(store) {
    return !!(store.currentProfile === 'ROLE_WEB_MUSIC_ADDITIONAL_ACCESS');
  },
  isFullAccess(store) {
    return store.access === 'full';
  },
  isEmptyAccess(store) {
    return store.access === 'empty';
  },
  isDemoAccess(store) {
    return store.access === 'demo';
  },
  hasAgentRole(store) {
    if (store.user.roles.includes('ROLE_LECTOR')) return true;
    return false;
  },
  isOnlyParentRole(store) {
    if (store.user?.roles?.includes('ROLE_PARENT') && !store.user.roles.includes('ROLE_LECTOR')) return true;
    return false;
  },
  isOnlyAgentRole(store) {
    if (store.user?.roles?.includes('ROLE_LECTOR') && !store.user.roles.includes('ROLE_PARENT')) return true;
    return false;
  },
  hasAdditionalAccessRole(store) {
    return !!store.user?.roles?.includes('ROLE_WEB_MUSIC_ADDITIONAL_ACCESS');
  },
  isProfileSelected(store) {
    return !!store.currentProfile;
  },
  getAgentData(store) {
    return store.agentData;
  },
  getAdditionalAccessData(store) {
    return store.additionalAccessData;
  },
  getIsLogoutBlocked(store) {
    return store.isLogoutBlocked;
  },
};
